import React from 'react';

import { Calendar } from 'primereact/calendar';
import { MultiSelect } from 'primereact/multiselect';
import { Tooltip } from 'primereact/tooltip';
import { usePracticeAreaList } from 'hooks/usePracticeAreaList';
import { Dropdown } from 'primereact/dropdown';
import { generateFullName } from 'utils/generateFullNameUtils';
import { useFirmUserList } from 'hooks/useFirmUserList';
import { LoaderComponent } from 'shared/LoaderComponent';
import { InputSwitch } from 'primereact/inputswitch';

export default function Filter({
  filter,
  filterOnChange,
  resetReportFilter,
  accList,
  isAccountsLoading,
  userContext,
  handleFilterUpdate,
  reportType,
}) {
  const { practiceAreaList, isPracticeAreaLoading } = usePracticeAreaList(true, 10, 'all', true);
  const { userList, isFirmUserLoading } = useFirmUserList(false, false, true);

  const assignToItemTemplate = (option) => {
    return (
      <>
        {option?.firm_user_id && <i className="fas fa-user-tie me-2"></i>}
        {generateFullName(option)}
      </>
    );
  };

  return (
    <div className="filter-wrap mb-3 report-filters-wrap">
      <div className="d-flex flex-wrap w-100 align-items-center p-2 filter-wraper gap-8">
        <div className="text-bold black-600 me-2 filter-label">Filters: </div>
        <div className="d-flex flex-column filter-wraper">
          <Calendar
            name="report_start"
            id="icon"
            dateFormat="mm/dd/yy"
            maxDate={filter?.report_end}
            className="input-shadow filter-calender"
            value={filter?.report_start}
            onChange={filterOnChange}
            inputClassName="w-110"
            showIcon
            placeholder="From Date"
          />
        </div>
        <div className="d-flex flex-column filter-wraper">
          <Calendar
            id="icon"
            name="report_end"
            minDate={filter?.report_start}
            dateFormat="mm/dd/yy"
            className="input-shadow filter-calender"
            value={filter?.report_end}
            onChange={filterOnChange}
            inputClassName="w-110"
            showIcon
            placeholder="To Date"
          />
        </div>
        <div className="d-flex flex-column filter-wraper">
          <Dropdown
            name="account_list"
            value={Array.isArray(filter?.account_list) ? filter.account_list[0] : filter?.account_list}
            options={accList}
            optionLabel="account_name"
            optionValue="account_id"
            onChange={filterOnChange}
            placeholder="Account"
            className="searchable-dropdown input-shadow"
            panelFooterTemplate={isAccountsLoading ? LoaderComponent : null}
          />
        </div>
        <div className="d-flex flex-column filter-wraper">
          <MultiSelect
            name="practice_area_list"
            value={isPracticeAreaLoading || !practiceAreaList.length ? [] : filter?.practice_area_list}
            options={practiceAreaList}
            onChange={filterOnChange}
            placeholder="Practice Area"
            optionLabel="practice_area_name"
            // optionValue="practice_area_name"
            optionValue="practice_area_id"
            display="chip"
            filter
            className="searchable-dropdown input-shadow"
            panelFooterTemplate={isPracticeAreaLoading ? LoaderComponent : null}
          />
        </div>
        <div className="d-flex flex-column filter-wraper">
          <MultiSelect
            name="lead_attorney_list"
            value={isFirmUserLoading || !userList.length ? [] : filter?.lead_attorney_list}
            options={userList}
            onChange={filterOnChange}
            optionLabel={(v) => generateFullName(v)}
            optionValue="client_cognito_username"
            placeholder="Lead Attorney"
            className="searchable-dropdown input-shadow"
            filter
            display="chip"
            resetFilterOnHide
            showClear
            itemTemplate={assignToItemTemplate}
            panelFooterTemplate={isFirmUserLoading ? LoaderComponent : null}
          />
        </div>
        <div className="d-flex flex-column me-md-2 filter-wraper">
          <div className="d-flex align-items-center">
            <InputSwitch
              className="input-swich"
              name="retain_filters"
              onChange={(e) => {
                e.preventDefault();
                handleFilterUpdate(e);
              }}
              checked={userContext?.firmDetails?.user_preferences?.filters?.report?.[reportType]?.retain_filters}
              tooltip="Retain Filters"
              tooltipOptions={{ position: 'top' }}
            />
            <label className="p-medium ms-1">Retain Filters</label>
          </div>
        </div>
        <div className="d-flex flex-column text-center">
          <div className="pointer ms-0">
            <i className="fas fa-sync-alt" onClick={resetReportFilter}></i>
            <Tooltip content="Reset Filter" position="top" target=".fa-sync-alt" showDelay={500} />
          </div>
        </div>
      </div>
    </div>
  );
}
